@if (showLeagueLogo) {
    <ms-competition-logo [sportId]="event.sport.id" [leagueId]="event.league.id" />
}
<span
    class="event-switcher-title"
    [class.expanded]="expanded"
    [class.disabled]="isDisabled"
    [msWhenOverflowed]="overflowOptions"
    (click)="toggleSwitcher()">
    {{ title }}
</span>
<vn-icon
    name="theme-right"
    ngClass="event-switcher-epcot-icons event-switcher-icons"
    [size]="epcotEnabled ? '13' : '12'"
    [class.expanded]="expanded"
    [class.disabled]="isDisabled" />
@if (showOnboarding) {
    <ms-event-switcher-onboarding />
}
